import CommonReducer from "app/NativeReducers/CommonReducer";
import PartnerReducer from "app/NativeReducers/PartnerReducer";
import FileReducer from "app/NativeReducers/FileReducer";
export default {
  native: CommonReducer,
  partner: PartnerReducer,
  file: FileReducer
};
